import { render, staticRenderFns } from "./RecursiveChoice.vue?vue&type=template&id=04d502a4&scoped=true&"
import script from "./RecursiveChoice.vue?vue&type=script&lang=ts&"
export * from "./RecursiveChoice.vue?vue&type=script&lang=ts&"
import style0 from "./RecursiveChoice.vue?vue&type=style&index=0&id=04d502a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d502a4",
  null
  
)

export default component.exports